import { render } from "./HorseEditMainDates.vue?vue&type=template&id=7c9b8e58"
import script from "./HorseEditMainDates.vue?vue&type=script&lang=js"
export * from "./HorseEditMainDates.vue?vue&type=script&lang=js"

import "./HorseEditMainDates.vue?vue&type=style&index=0&id=7c9b8e58&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__